import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './supporting/style/index.css';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);